var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeIncomplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 29,
    viewBox: "0 0 96 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.875,
    width: 94.5,
    height: 27.75,
    rx: 13.875,
    stroke: "#FC5955",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1085_20271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0114 9.03516C15.2607 9.3459 14.5786 9.80144 14.0039 10.3758",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6619 12.3867C12.3501 13.1363 12.1889 13.9399 12.1875 14.7517",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6602 17.1133C12.9709 17.864 13.4264 18.5461 14.0008 19.1208",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0117 20.4648C16.7613 20.7766 17.5649 20.9378 18.3767 20.9392",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7383 20.4617C21.489 20.151 22.1711 19.6954 22.7458 19.1211",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0898 17.115C24.4016 16.3654 24.5628 15.5618 24.5642 14.75",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0867 12.3864C23.776 11.6357 23.3204 10.9536 22.7461 10.3789",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.74 9.03688C19.9904 8.72513 19.1868 8.56395 18.375 8.5625",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 14.75L17.6875 16.125L20.4375 13.375",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9467 10.501H48.3147V16.6855H43.9467V10.501ZM47.4642 11.2045H44.7972V15.982H47.4642V11.2045ZM50.2992 9.5665H51.1707V19.0795H50.2992V9.5665ZM55.5169 13.5145H56.3884V14.953H55.5169V13.5145ZM55.9264 10.0075C57.3019 10.0075 58.2679 10.7635 58.2679 11.887C58.2679 13.0105 57.3019 13.756 55.9264 13.756C54.5614 13.756 53.5954 13.0105 53.5954 11.887C53.5954 10.7635 54.5614 10.0075 55.9264 10.0075ZM55.9264 10.6795C55.0339 10.6795 54.4144 11.173 54.4144 11.887C54.4144 12.6115 55.0339 13.0945 55.9264 13.0945C56.8294 13.0945 57.4489 12.6115 57.4489 11.887C57.4489 11.173 56.8294 10.6795 55.9264 10.6795ZM59.5489 9.5875H60.4204V16.843H59.5489V9.5875ZM60.0529 12.79H61.8064V13.5145H60.0529V12.79ZM54.4144 18.1345H60.7564V18.859H54.4144V18.1345ZM54.4144 16.2235H55.2859V18.4495H54.4144V16.2235ZM53.1649 15.436L53.0494 14.722C54.7189 14.722 57.0289 14.701 58.9609 14.407L59.0239 15.0475C57.0394 15.415 54.7924 15.436 53.1649 15.436ZM65.1236 15.142H65.9846V17.473H65.1236V15.142ZM68.1581 15.121H69.0086V17.4625H68.1581V15.121ZM62.7296 17.179H71.3291V17.9035H62.7296V17.179ZM63.7691 10.2805H70.2686V13.147H64.6616V15.058H63.8006V12.454H69.4076V10.984H63.7691V10.2805ZM63.8006 14.6695H70.4891V15.3835H63.8006V14.6695Z",
    fill: "#FC5955"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1085_20271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(10.125 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIncomplete);
export default __webpack_public_path__ + "static/media/badge_incomplete.9ea09485cd3def5be92ca0ff724f0136.svg";
export { ForwardRef as ReactComponent };